import React from 'react';
import { trans, useSoyuzLocales } from '@spotahome/soyuz/client';

import { LandlordAppBanner } from '@spotahome/ui-library';

import '@common/scss/init.scss';

import Cookies from '@common/components/Cookies';
import SessionExpiredModal from '@common/components/SessionExpiredModal';
import FAQSection from '@common/components/FAQSection';

import ServicePlanSection from './components/ServicePlans/ServicePlanSection';
import HeroLandlord from './components/HeroLandlord';
import PhoneScrollerSection from './components/PhoneScrollerSection';
import FeatureBoxSection from './components/FeatureBoxSection';
import LandlordQuoteSection from './components/LandlordQuoteSection';
import LandlordGuaranteeSection from './components/LandlordGuaranteeSection';
import FooterLandlord from './components/FooterLandlord';

import ShowcaseBookingRequestSection from './components/ShowcaseBookingRequestSection';
import LandlordStatsSection from './components/LandlordStatsSection';
import TenantsBubbleSection from './components/TenantsBubbleSection';
import CustomerSupportSection from './components/CustomerSupportSection';

const LandlordLandingPageContainer = () => {
  const isSpanishLocale = useSoyuzLocales().current === 'es';

  return (
    <div className="landlord-landing">
      <LandlordAppBanner
        title={trans('appbanner.landlord.title')}
        ctaText={trans('appbanner.continue')}
      />
      <HeroLandlord />
      <FeatureBoxSection />
      <PhoneScrollerSection />
      <TenantsBubbleSection />
      <ShowcaseBookingRequestSection />
      <LandlordQuoteSection />
      <LandlordGuaranteeSection />
      <CustomerSupportSection />
      <LandlordStatsSection />
      {isSpanishLocale && <ServicePlanSection />}
      <FAQSection />
      <FooterLandlord />
      <SessionExpiredModal />
      <Cookies />
    </div>
  );
};

LandlordLandingPageContainer.NAME = 'LandlordLandingName';

export default LandlordLandingPageContainer;
